module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageCalendar",
    staticClass: ["wxc-page-calendar"],
    style: {
      height: _vm.pageHeight + 'px'
    }
  }, [_c('wxc-minibar', _vm._b({
    attrs: {
      "show": _vm.showHeader,
      "useDefaultReturn": _vm.useDefaultReturn
    },
    on: {
      "wxcMinibarLeftButtonClicked": _vm.minibarLeftButtonClick
    }
  }, 'wxc-minibar', _vm.minibarCfg, false)), (_vm.isShow) ? _c('div', {
    staticClass: ["calendar-weekday"]
  }, _vm._l((['日', '一', '二', '三', '四', '五', '六']), function(week, k) {
    return _c('text', {
      key: k,
      staticClass: ["flex-item", "weekday-text"]
    }, [_vm._v(_vm._s(week))])
  })) : _vm._e(), (_vm.isShow) ? _c('list', {
    staticClass: ["calendar-list"],
    style: {
      height: _vm.calendarHeight + 'px'
    }
  }, _vm._l((_vm.monthsArray), function(month, index) {
    return _c('cell', {
      key: index,
      appendAsTree: true,
      attrs: {
        "append": "tree"
      }
    }, [_c('div', {
      staticClass: ["calendar-month"]
    }, [_c('text', {
      staticClass: ["month-text"]
    }, [_vm._v(_vm._s(month.title))])]), _vm._l((month.rowsData), function(row, rowIndex) {
      return _c('div', {
        key: rowIndex,
        staticClass: ["calendar-row"]
      }, _vm._l((row.cells), function(cell, index) {
        return _c('div', {
          key: index,
          ref: cell.ref,
          refInFor: true,
          class: ['row-item', cell.cellClass],
          on: {
            "click": function($event) {
              _vm.onClickDate(cell)
            }
          }
        }, [(cell.isEmpty) ? _c('div') : _vm._e(), (!cell.isEmpty) ? _c('div', {
          staticClass: ["calendar-item"]
        }, [_c('text', {
          class: ['calendar-note', cell.cls]
        }, [_vm._v(_vm._s(cell.note))]), _c('text', {
          class: ['calendar-day', cell.cls]
        }, [_vm._v(_vm._s(cell.text))]), _c('text', {
          class: ['calendar-ext', cell.cls]
        }, [_vm._v(_vm._s(cell.ext))])]) : _vm._e()])
      }))
    })], 2)
  })) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./node_modules/weex-vue-loader/lib/template-compiler.js?id=data-v-774c3f00!./node_modules/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-page-calendar/index.vue
// module id = 118
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28